import templateUrl from "emun.auth/login-prompt.htm";
import actionsTemplateUrl from "emun.auth/login-prompt.actions.htm";
import controller from "emun.auth/login-prompt.controller";
import open from "webmodals/open";
import "emun.auth/login-prompt.client.scss";

export const IS_CMS =
	(ENV_TAGS || []).indexOf("Cms") >= 0;

export default ({
  size = "md login-prompt",
  backdrop = "static",
  authProvider = "emun",
  password,
  userName,
  continuationBehavior = !IS_CMS ? null : 'reload',
  title = "Sign in to your account",
  rememberMe = true,
  viewOverride = true
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      title: () => title,
      actionsTemplateUrl: () => actionsTemplateUrl,
      request: () => ({
        authProvider,
        userName,
        password,
        continuationBehavior,
        rememberMe,
        viewOverride
      }),
    },
  }).result;
